// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_tuesday = /** @type {(inputs: {}) => string} */ () => {
	return `Tuesday`
};

const el_tuesday = /** @type {(inputs: {}) => string} */ () => {
	return `Τρίτη`
};

const ru_tuesday = /** @type {(inputs: {}) => string} */ () => {
	return `Вторник`
};

const he_tuesday = /** @type {(inputs: {}) => string} */ () => {
	return `יום שלישי`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tuesday = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tuesday(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("tuesday", locale)
	if (locale === "en") return en_tuesday(inputs)
	if (locale === "el") return el_tuesday(inputs)
	if (locale === "ru") return ru_tuesday(inputs)
	if (locale === "he") return he_tuesday(inputs)
	return "tuesday"
};